

export class BranchDetailsIdDataInput implements IBranchDetailsIdDataInput {
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;

    constructor(data?: IBranchDetailsIdDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
        }
    }

    static fromJS(data: any): BranchDetailsIdDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailsIdDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        return data; 
    }
}

export interface IBranchDetailsIdDataInput {
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
}

